import axios from 'axios';
// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_REACT_APP_API_ENDPOINT,
});

axiosInstance.defaults.headers.common.Accept = 'application/json';
export default axiosInstance;
